export const LOGIN = '/login'
export const FORGOTPASSWORD = '/forgot-password'
export const RESETPASSWORD = '/reset-password'
export const DASHBOARD = '/dashboard'
export const ADMINDEPARTMENT = '/admin/department'
export const EMPLOYEES = '/employees'
export const ADDNEWEMPLOYEE = '/add-new-employee'
export const EMPLOYEEDETAIL = '/employees-detail'
export const ATTENDANCESHEET = '/attendance-sheet'
export const MANUALATTENDANCE = '/manual-attendance'
export const TAXDECLARATION = '/tax-declaration'
export const PROOFOFINVESTMENT = '/proof-of-investment'
export const ATTENDANCEDETAIL = '/attendance-detail'
export const LEAVESREQUEST = '/leaves-request'
export const LEAVESBALANCE = '/leaves-balance'
export const HOLIDAYS = '/holidays'
export const REGULARISATION = '/regularisation'
export const REGULARISATIONDETAIL = '/regularisation-detail'
export const PAYROLL = '/payroll'
export const PAYROLLRELEASE = '/payroll-release'
export const TAX = '/tax'
export const INVESTMENTDECLARATIONDETAIL = '/investment-declaration-detail'
export const PROOFDECLARATIONDETAIL = "/proof-declaration-detail"
export const PROFILE = '/profile'
export const SALARYHISTORY = '/salary-history'
export const ROLES = '/roles'
export const NEWROLE = '/new-role'
export const USERS = '/users'
export const PAGES = '/pages'
export const LEAVEMANAGEMENT = '/leave-management'
export const NEWPAGE = '/new-page'
export const Master = '/master/branch'
export const BRANCH = '/master/branch'
export const INDUSTRYTYPE = '/master/industry-type'
export const COMPANY = '/master/company'
export const DOCUMENT = "/master/document"
export const EMPLOYEEDOCUMENT = "/master/employee-document"
export const SCORE = '/master/score'
export const BANKNAME = '/master/bank-name'
export const BLOODGROUP = '/master/blood-group'
export const SHIFT = '/master/shift'
export const DEGREE = '/master/degree'
export const JOBPROFILE = '/master/job-profile'
export const HOLIDAYMASTER = '/master/holiday-master'
export const BALANCELEAVE = '/master/balance-leave'
export const MASTERDEPARTMENT = '/master/department'
export const GENDER = '/master/gender'
export const MARITALSTATUS = '/master/marital-status'
export const RELATION = '/master/relation'
export const REFERENCE = '/master/reference'
export const LEAVEMASTER = '/master/leave-master'
export const REGULARIZATIONSETTING = '/master/regularization-Setting'
export const EMPLOYEESTATUS = '/master/employee-status'
export const CANDIDATEMASTER = '/master/candidate-master'
export const PAYROLLCOMPANY = '/master/payroll-company'
export const BUSINESSPROCESS = '/master/business-process'
export const EDUCATIONDEGREE = '/master/education-degree'
export const EDUCATIONCATEGORIES = '/master/education-categories'
export const JOBSKILLS = '/master/jobSkills'
export const JOBWORKMOOD = '/master/jobWorkMood'
export const EMPLOYMENTTYPE = '/master/employmentType'
export const TDSLAB = '/master/tds-slab'
export const CODEOFCONDUCT = '/master/code-of-conduct'
export const PAYSLIPS = '/payslips'
export const FORM16 = '/form16'
export const SALARYSTRUCTUREVIEW = '/salaryStructureView'
export const MYDEPARTMENT = '/my-department'
export const ATTENDANCEINFO = '/attendanceInfo'
export const REGULARISATIONREQUEST = '/regularizationRequest'
export const MYLEAVES = '/my-leaves'
export const LEAVEAPPLY = '/leave-apply'
export const LEAVEBALANCES = '/leave-balances'
export const LEAVECALENDAR = '/leave-calendar'
export const HOLIDAYCALENDAR = '/holiday-calendar'
export const MYTAXDECLARATION = '/myTaxDeclaration'
export const MYPROOFOFINVESTMENT = '/myProofOfInvestment'
export const OLDTAXDECLARATION = '/oldTaxDeclaration'
export const NEWTAXDECLARATION = '/newTaxDeclaration'
export const OLDPOI = '/oldpoi'
export const NEWPOI = '/newpoi'
export const MYPROFILE = '/myProfile'
export const DocumentCategory = '/master/documentCategory'
export const THOUGHTOFTHEDAY = '/master/thought-of-the-day'
export const RecruitmentDashboard = '/recruitement-dashboard'
export const ANNOUNCEMENT = '/master/announcement'
export const LEAVEREASON = '/master/leave-reason'
export const TERMINATIONTYPE = '/master/termination-type'
export const ACTIVEJOBS = '/active-jobs'
export const CLOSEDJOBS = '/closed-jobs'
export const CANDIDATELIST = '/candidate-list'
export const CANDIDATEDETAILS = '/candidate-details'
export const CANDIDATEPUBLICFORM = '/candidate-external-form'
export const CANDIDATETHANKYOUPAGE = '/CandidateThankYouPage'
export const ATTENDANCESETTING = '/attendance-setting'
export const OFFERSONBORDING = '/offers&onbording'
export const ONBOARDINGCANDIDATEPROFILE = '/onboardingCandidateProfile'
export const ONBOARDINGCANDIDATELIST = '/onboardingCandidateList'
export const JOBOFFERSTATUS = '/job-offer-status'
export const ONBOARDINGAPPLICANT = '/onboarding-applicant'
export const ACCEPTANCESUCCESS = '/acceptance-success'
export const REJECTEDSUCCESS = '/rejected-success'
export const OTPVERIFICATION = '/otp-verification'
export const RESIGNATION = '/resignation'
export const CURRENTJOBOPENINGS = '/CurrentJobOpenings'
export const REFFERALCANDIDATELIST = '/referral-candidate-list'
export const RESIGNATIONAPPROVAL = '/resignation-approval'
export const TERMINATIONANDABSCOND = '/termination-and-abscond'
export const REGULARIZATIONAPPROVALSETTING = '/RegularizationApprovalSetting'
export const REMOTEREQUEST = '/remoteRequest';
export const REMOTEAPPROVAL = '/remoteApproval';
export const REMOTEWORKTIMEAPPROVAL = '/remote-worktime-approval'
export const MISSINGDOCUMENTS = '/missing-documents'
export const EMAILTEMPLATE = '/email-template'
export const TICKETGROUP = '/ticket-group'
export const RAISETICKET = '/raiseTicket'
export const GROUPHIERARCHY = '/GroupHierarchy'
export const APPLICATIONGROUP = '/application-group'
export const TICKETASSIGNMENT = '/TicketAssignment'
export const ASSIGNEDTICKET = "/AssignedTicket"
export const TICKETDETAIL = "/ticket-detail"
export const CANDIDATEREPORT = '/candidate-report'
export const IVRREPORT = '/ivr-report'
export const EMPLOYEEEXITRESPONSIBILITY = '/employee-exit-responsibility'
export const EXITCLEARANCE = '/exit-clearance'
export const EXITCLEARANCETASKMASTER = '/master/exit-clearance-task-master'
export const NOTICEPERIOD = '/master/notice-period'
export const RESIGNATIONEMAILSETTING = "/master/resignation-email-setting"
export const REALEASEDEMPLOYEE = "/released-employee"
export const SEPARATIONREASON = "/master/separation-reason"
export const ACCOUNTSBUYOUTPROCESSING = "/accounts-buyout-processing"
export const EMPLOYEEGALLERY = "/employee-gallery"
export const RELEASEEMPLOYEEDOCUMENT = "/released-emp-document"
export const WELCOMEMAIL = "/welcome-mail"
export const EMAILSETTING = "/emailSetting"
export const MANAGEMENTINTRACTION = "/management-interaction"
export const MEMBERINTRACTION = "/member-interaction"
export const REJECTEDCANDIDATEPUBLICFORM = "/rejected-candidate-external-form"
export const MEETINGSMANAGEMENT = "/meetings-management"
export const HRASSIGNEMENTSUMMARY = "/hr-assignement-summary"
export const HRMANUALASSIGNMENT = "/hr-manual-assignment"
export const EMPLOYEEREFERRALPUBLICFORM = "/employee-referral-external-form"
export const SALARYCALCULATIONSETTING = "/salary-calculation-setting"
export const MYAWARD = '/my-award';
export const ADMINCERTIFICATE = '/award-list'
export const AWARDSCERTIFICATECATEGORY = '/master/award-category'
export const MYTASK = '/task/my-task'
export const TASKLIST = '/task/task-list'
export const EMPLOYEETASKLIST = '/task/employee-task-list'
export const MYMEETING = "/my-meeting"
export const IVRCALLING = '/master/ivr-calling'
export const DISCIPLINESETTING = '/discipline-setting'
export const INCREMENTSLABSETTING = '/increment-slab-setting'
export const WEIGHTAGECONFIGURATION = '/weightage-configuration'
export const PERFOMANCEMATRIX = "/perfomance-matrix"
export const INCREMENTGENERALSETTING = '/increment-general-setting';
export const EMPLOYEECATEGORY = '/employee-category'
export const SALESRECRUITEREFFORT = '/sales-recruiter-effort'
export const PERFOMANCECALCULATION = "/perfomance-calculation"
export const AUTOATTENDANCECONFIG = "/auto-attendance-config"
export const APPRAISALDASHBOARD = '/appraisal-dashboard'
export const EMPLOYEEINCREMENT = "/employee-increment"
export const MANAGERTEAMASSESMENT = "/manager-assesment"
export const RUNMANAGERASSESMENT = '/run-manager-assesment'
export const ELIGIBILITYOVERRIDE = "/eligibility-override"
export const ASSESSMENTSSETTING = "/assessment-setting"
export const ATTENDANCEREPORTPage = "/attendance-report-list"
export const ASSESSMENTAPPROVAL = "/assessment-approval"
export const INCREMENTASSESSMANTAPPROVAL = "/increment-assessment-approval"
export const APPRAISALACTIONSPAGE = "/appraisal-actions-page"
export const ASSESSMENTBYPASS = "/assessment-bypass"
export const DOCS = "/docs"
export const DOWNLOADVERIFY = "/download/:token"
export const PROJECT = '/master/project'
export const OFFERLETTERTEMPLATE = "/offer-letter-template"
export const APPOINTMENTLETTERTEMPLATE = "/appointment-letter-template"
export const COMPANYDOCUMENTCATEGORY = '/master/company-document-category'
export const COMPANYDOCUMENT = "/master/company-document"
export const ASSETMASTER = "/master/asset-master"
export const ASSETENTRY = "/asset-entry"
export const INTERNALMAILCOMPOSER = "/internal-mail-composer"
export const GROUPMAIL = '/master/group-email'
